export const TRANSFER_STEP_SESSION_KEY = 'offshore2go_dashboard_transfer_step';

export const clearDashboardTransferStepSession = () => {
  sessionStorage.removeItem(TRANSFER_STEP_SESSION_KEY);
};
